export const REDUCER_NAME = "instagramAdsetSlice";
// ==========================
// Create AdSet DTO
// ==========================

export interface iInstagramAdsetCreateDTO {
  name: string;
  campaign_id: string;
  daily_budget: string;  // must be numeric string
  billing_event: "IMPRESSIONS" | "LINK_CLICKS" | "APP_INSTALLS";
  optimization_goal:
  | "LEAD_GENERATION"
  | "REACH"
  | "IMPRESSIONS"
  | "LINK_CLICKS";
  bid_strategy:
  | "LOWEST_COST_WITHOUT_CAP"
  | "LOWEST_COST_WITH_BID_CAP"
  | "COST_CAP";

  ageMin: number;
  ageMax:  number;
  advantageAudience:  number;
  genders: string[];
  countries: string[];
  adsetId?: string;
  status?: string;
}

// ==========================
// AdSet Response DTO
// ==========================

// export interface iInstagramAdsetDTO {
//   id: string;
//   name?: string;
//   status?: "ACTIVE" | "PAUSED" | "DELETED";
//   campaign_id?: string;
//   daily_budget?: string;
//   optimization_goal?: string;
//   billing_event?: string;
//   bid_strategy?: string;
//   created_time?: string;
// }

export interface iInstagramAdsetDTO {
  id: string;
  name?: string;
  status?: "ACTIVE" | "PAUSED" | "DELETED";
  created_time?: string;
  campaign_id?: string;
  campaign?: {
    id: string;
  };

  targeting?: {
    age_min?: number;
    age_max?: number;
    genders?: number[];
    geo_locations?: {
      countries: string[];
      location_types?: string[];
    };
    targeting_automation?: {
      advantage_audience: number;
    };
    publisher_platforms?: string[];
  };

  daily_budget?: string;
  optimization_goal?: string;
  billing_event?: string;
  bid_strategy?: string;
}



export interface iInstagramAdsetState {
  instagramAdsetList: iInstagramAdsetDTO[] | null;
  isLoading: boolean;
  errorMessage: string | null;
}
